module.exports = __webpack_public_path__ + "static/media/chisom.a2a5836c.png";